/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import compose from 'recompose/compose';

import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import { TextField, Checkbox } from 'formik-material-ui';

import {
    withStyles,
    Typography,
    CircularProgress,
    CardContent,
} from '@material-ui/core';
import InformationDialog from '../../components/InformationDialog';
import styles from './styles';
import logo from '../../logo.png';
import { postAutentication, logout } from '../../services/AuthApi';
import {
    isAuthenticated,
    persistUsuario,
    getUsuario,
    persistIdMembro,
    removerUsuario,
} from '../../services/api';
import { getPerfilUsuario } from '../../services/UserApi';

function SignIn(props) {
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    const [open, setOpen] = useState(false);
    const [grupoNaoCadastrado, setGrupoNaoCadastrado] = useState(false);

    useEffect(() => {
        if (isAuthenticated()) {
            props.history.push('/grupos');
            props.history.go();
        }
    }, [props.history, token]);

    const handleSignIn = async (values, { setSubmitting }) => {
        const { usuario, senha, isLembrarMe } = values;
        try {
            setError('');
            setSubmitting(true);
            const response = await postAutentication(usuario, senha);
            const perfil = await getPerfilUsuario();
            if (perfil.data.lider || perfil.data.professor) {
                setToken(response.token);
                if (isLembrarMe) {
                    persistUsuario(usuario);
                } else {
                    removerUsuario(usuario, perfil.data.idMembro);
                }
                persistIdMembro(perfil.data.idMembro);
            } else {
                logout();
                setGrupoNaoCadastrado(true);
            }
        } catch (err) {
            setError(
                'Dados incorretos. Tente novamente ou clique em "Esqueci minha senha" caso queira redefini-la.'
            );
        }
        setSubmitting(false);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseNaoGrupo = () => {
        setGrupoNaoCadastrado(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const { classes } = props;

    return (
        <Container
            component="main"
            maxWidth="xs"
            style={{
                display: 'flex',
                minHeight: '100vh',
            }}
        >
            <CssBaseline />
            <div className={classes.paper}>
                <Card className={classes.card}>
                    <CardContent
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <img className={classes.img} src={logo} />
                        <Formik
                            initialValues={{
                                usuario: getUsuario(),
                                senha: '',
                                isLembrarMe: !!getUsuario(),
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSignIn(values, { setSubmitting });
                            }}
                            validationSchema={Yup.object().shape({
                                usuario: Yup.lazy(value => {
                                    if (!isNaN(value)) {
                                        return Yup.string()
                                            .length(
                                                5,
                                                'Matrícula deve ter 5 digitos!'
                                            )
                                            .required(
                                                'Matrícula ou E-mail devem ser informados'
                                            );
                                    }
                                    return Yup.string()
                                        .email('Matrícula ou E-mail invalído!')
                                        .required(
                                            'Matrícula ou E-mail devem ser informados'
                                        );
                                }),
                                senha: Yup.string().required(
                                    'Senha deve ser informada'
                                ),
                            })}
                        >
                            {props => {
                                const {
                                    touched,
                                    errors,
                                    isSubmitting,
                                    submitForm,
                                    values,
                                    handleSubmit,
                                } = props;
                                return (
                                    <form
                                        onSubmit={handleSubmit}
                                        className={classes.form}
                                    >
                                        <Field
                                            component={TextField}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            id="usuario"
                                            label="Matrícula ou E-mail"
                                            name="usuario"
                                            autoComplete="usuario"
                                            helperText={
                                                errors.usuario &&
                                                touched.usuario &&
                                                errors.usuario
                                            }
                                            type="text"
                                            autoFocus
                                        />
                                        <Field
                                            component={TextField}
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            name="senha"
                                            label="Senha"
                                            type="password"
                                            id="senha"
                                            helperText={
                                                errors.senha &&
                                                touched.senha &&
                                                errors.senha
                                            }
                                            autoComplete="current-senha"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Field
                                                    component={Checkbox}
                                                    value="isLembrarMe"
                                                    id="lembrar"
                                                    name="isLembrarMe"
                                                    checked={values.isLembrarMe}
                                                    color="primary"
                                                />
                                            }
                                            label="Lembrar-me"
                                        />
                                        <div className={classes.wrapper}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                className={classes.submit}
                                                onClick={submitForm}
                                                disabled={isSubmitting}
                                                type="submit"
                                            >
                                                Entrar
                                            </Button>
                                            {isSubmitting && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </div>
                                        <Typography
                                            align="center"
                                            color="error"
                                            variant="body1"
                                            className={classes.error}
                                        >
                                            {error}
                                        </Typography>
                                        <Grid container>
                                            <Grid item xs>
                                                <Link
                                                    href="#"
                                                    onClick={e => {
                                                        handleOpen();
                                                    }}
                                                    variant="body2"
                                                >
                                                    Esqueci minha senha
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </form>
                                );
                            }}
                        </Formik>
                    </CardContent>
                </Card>
            </div>
            <InformationDialog
                titulo="Esqueci Minha Senha"
                handleClose={handleClose}
                open={open}
            >
                <b>Importante: A senha é a mesma do app Aluno Senib.</b> Se você
                é líder de GA e esqueceu sua senha ou não possui uma ainda, você
                pode gerenciá-la pelo aplicativo, disponível para Android e iOS.
                Se ainda assim tiver dificuldades, entre em contato via whatsapp
                pelo número <b>99205-0094</b> ou envie um e-mail para{' '}
                <b>cadastro@nib.org.br</b> com seu nome completo, e-mail,
                telefone celular, data de nascimento e matrícula que
                providenciaremos uma pra você.
            </InformationDialog>
            <InformationDialog
                titulo="Usuário não lidera GA"
                handleClose={handleCloseNaoGrupo}
                open={grupoNaoCadastrado}
            >
                Este usuário não consta como líder em nenhum GA cadastrado. Para
                mais informações entre em contato via Whatsapp pelo número{' '}
                <b>99205-0094</b> ou envie um e-mail para{' '}
                <b>cadastro@nib.org.br</b>.
            </InformationDialog>
        </Container>
    );
}

export default compose(withStyles(styles))(withRouter(SignIn));
